// extracted by mini-css-extract-plugin
export default {"container":"AdminAccounting_container__ulRxW","statsGrid":"AdminAccounting_statsGrid__IKNf8"};